
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us-economy/us-gdp",
      function () {
        return require("private-next-pages/us-economy/us-gdp.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us-economy/us-gdp"])
      });
    }
  